import script from "./ViewMyChildrenClassRecordDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMyChildrenClassRecordDialog.vue?vue&type=script&setup=true&lang=js"

import "./ViewMyChildrenClassRecordDialog.vue?vue&type=style&index=0&id=7ea73c19&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea73c19"]])

export default __exports__